module.exports = function getResource(label, vars = []) {
    let resources = {
        freeShippingMessage: `Plus que ${vars[0]} pour avoir droit à la livraison gratuite.`
    };

    return resources[label];
};
